import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-skeleton-box',
    template: `
        <div
            class="skeleton-shimmer"
            [ngClass]="shapeClass"
            [style.width]="width"
            [style.height]="height"
            [style.borderRadius]="borderRadius"
            [style.margin]="margin"
        ></div>
    `,
    styles: [`
        :host {
            display: inline-block;
            vertical-align: middle;
        }
        .shape-circle {
            border-radius: 50% !important;
        }
        .shape-pill {
            border-radius: 9999px !important;
        }
    `]
})
export class SkeletonBoxComponent {
    @Input() width: string = '100%';
    @Input() height: string = '16px';
    @Input() borderRadius: string = '6px';
    @Input() shape: 'rect' | 'circle' | 'pill' = 'rect';
    @Input() margin: string = '0';

    get shapeClass(): string {
        if (this.shape === 'circle') return 'shape-circle';
        if (this.shape === 'pill') return 'shape-pill';
        return '';
    }
}
